module.exports = __webpack_public_path__ + "img/upload_icon.3c0f86bf.svg";